import InternalDynamicAnchorRanking from 'models/application/anchor/types/internalDynamic/types/Ranking';

export default class InternalDynamicAnchorRankingService {
	toModel(anchor) {
		return new InternalDynamicAnchorRanking(anchor);
	}
}
